import * as RS from 'react-select';
import * as RS3 from 'react-select3';
export var ReactSelect = RS.default;
export var ReactSelect3 = RS3.default;
export var ReactSelect3Components = RS3.components;
export var ReactSelectAsync = RS.Async;
export var ReactSelectCreatable = RS.AsyncCreatable;
//# sourceMappingURL=react-select.js.map